import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Container,
  Box,
  AppBar,
  Toolbar,
  Typography,
} from "@mui/material";
import { tokens } from "../theme";

const MainPage: React.FC = () => {
  const [inputText, setInputText] = useState("");
  const navigate = useNavigate();

  const handleSend = () => {
    navigate(`/results/${inputText}`);
  };

  return (
    <>
      <AppBar position="static">
        <Toolbar style={{ width: "100vw" }}>
          <Typography sx={{ fontWeight: 700, color: tokens.ink }}>[ DEBUG TOOL ]</Typography>
        </Toolbar>
      </AppBar>
      <Container>
        <Box mt={5}>
          <TextField
            label="Enter transaction ID"
            variant="outlined"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSend}
            sx={{ mt: 2 }}
          >
            [ lookup ]
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default MainPage;
